/**
 * Widget-local hook: reads the current selection geometry from `selectionGraphic`.
 *
 * Current app UX (Feb 2026): selection is driven by `ZoomToGeo` (dropdown-based),
 * not by manual drawing inside RasterStatistics. RasterStatistics only needs the
 * geometry to enable/disable actions and to pass selection to backend requests.
 */

import { useMemo } from "react";

import APIHelper from "@giscon/utils.api-helper-esri";
import { getSelectionGraphic } from "utils/possibilities";

const useSelectionGeometry = ({ CommunicationStore }) => {
  const { graphic: selectionGraphic } =
    getSelectionGraphic(CommunicationStore) || {};

  const geometry = useMemo(() => {
    return (
      (selectionGraphic && APIHelper.getGeometry(selectionGraphic)) || null
    );
  }, [selectionGraphic]);

  return { geometry };
};

export default useSelectionGeometry;
